import vAlert from "./v-alert.vue";
import vInlineAlerts from "./v-inlinealerts.vue";
import vGlobalAlerts from "./v-globalalerts.vue";
import vAlerts from "./v-alerts.vue";
import vArrow from "./v-arrow.vue";

export default Vue => {
  Vue.component("v-globalalerts", vGlobalAlerts);
  Vue.component("v-inlinealerts", vInlineAlerts);
  Vue.component("v-alerts", vAlerts);
  Vue.component("v-alert", vAlert);
  Vue.component("v-arrow", vArrow);
};
